import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

import type { BookingReservationStatus } from '@/types/api/queries';

import {
  BOOKING_STATUS_BADGE_VARIANTS,
  BOOKING_STATUS_LABEL_KEYS,
} from '@/constants';

import { StatusBadge } from '../StatusBadge';

type BookingStatusBadgesProps = {
  status: BookingReservationStatus;
  isUnassigned: boolean;
};

export const BookingStatusBadges = (props: BookingStatusBadgesProps) => {
  const { status, isUnassigned } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <StatusBadge
        size="sm"
        variant={BOOKING_STATUS_BADGE_VARIANTS[status]}
      >
        {t(BOOKING_STATUS_LABEL_KEYS[status])}
      </StatusBadge>
      {isUnassigned && (
        <StatusBadge
          size="sm"
          variant="destructive"
          className="gap-1"
        >
          <AlertTriangle className="size-3" />
          {t('Not assigned')}
        </StatusBadge>
      )}
    </div>
  );
};
